<template>
    <div class="box p-5" style="border-radius: 10px">
        <div class="is-mobile mb-0 is-flex is-flex-direction-column">
            <div class="is-flex is-flex-direction-row is-align-items-center">
                <span style="height: 100%; font-size: 18px" class="has-text-primary has-text-weight-bold">
                    {{ message.username }} 
                </span>
                <span style="margin-left: auto;"> {{ message.created_at }} </span>
            </div>
        </div>
        <div style="height: 1px; background: #e5e5e5" class="my-2"></div>
        <div class="is-mobile mb-0 is-flex is-flex-direction-column">
            {{ message.message }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        is_editable: {
            type: Boolean,
            default: false,
        },
        message: {
            type: Object,
        },
    },
};
</script>